import {componentLoader, componentConfig} from "../../../lib/component_initializer";
import {EnquireOption} from "./enquire_option";

export const enquireOptionLoader = function (options = {}) {
    componentLoader(componentConfig(EnquireOption, EnquireOption.config.componentTypeKey, EnquireOption.config.baseHtmlClass), options);
};

